import store from '@state/store'
import { lazyLoadView } from '@router/helpers'

export default [
  {
    path: '/login',
    name: 'login',
    component: () =>
      lazyLoadView(import(/* webpackChunkName: "login" */ './views/login.vue')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        store.commit('auth/SET_TRYING_TO_LOGIN', false)
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          store
            .dispatch('auth/validate', true)
            .then((user) => {
              var currentUser = store.state.auth.currentUser
              if (requiresCustomRedired()) {
                return
              }
              next({
                name: 'company',
                params: {
                  companyId:
                    currentUser.default_company_id &&
                    currentUser.default_company_id !== 0
                      ? currentUser.default_company_id
                      : currentUser.companies[0].id,
                },
              })
            })
            .catch(() => {
              next({ name: '404', params: { resource: 'Company' } })
            })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/organization-signup',
    name: 'organization-signup',
    component: () =>
      lazyLoadView(
        import(
          /* webpackChunkName: "organization-signup" */ './views/organization-signup.vue'
        )
      ),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'home' })
        } else {
          next()
        }
      },
    },
  },
  {
    path: '/organization-setup/info/:token',
    name: 'organization-setup-info',
    component: () =>
      lazyLoadView(
        import(
          /* webpackChunkName: "organization-setup-info" */ './views/organization-finish-setup-info.vue'
        )
      ),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'home' })
        } else {
          next()
        }
      },
    },
  },
  {
    path: '/organization-setup/social/:token',
    name: 'organization-setup-social',
    component: () =>
      lazyLoadView(
        import(
          /* webpackChunkName: "organization-setup-social" */ './views/organization-finish-setup-social.vue'
        )
      ),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'home' })
        } else {
          next()
        }
      },
    },
  },
  {
    path: '/organization-setup/admins/:token',
    name: 'organization-setup-admins',
    component: () =>
      lazyLoadView(
        import(
          /* webpackChunkName: "organization-setup-admins" */ './views/organization-finish-setup-admins.vue'
        )
      ),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'home' })
        } else {
          next()
        }
      },
    },
  },
  {
    path: '/login-by-phone',
    name: 'login-by-phone',
    component: () =>
      lazyLoadView(
        import(/* webpackChunkName: "login" */ './views/login-by-phone.vue')
      ),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'home' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () =>
      lazyLoadView(
        import(/* webpackChunkName: "login" */ './views/forgot-password.vue')
      ),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'home' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/createpassword/token/:token',
    name: 'createpassword',
    component: () =>
      lazyLoadView(
        import(
          /* webpackChunkName: "create-password" */ './views/create-password.vue'
        )
      ),
    meta: {
      tmp: {},
      beforeResolve(routeTo, routeFrom, next) {
        routeTo.meta.tmp.token = routeTo.params.token

        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'home' })
        } else {
          next()
        }
      },
    },
    props: (route) => ({
      token: route.meta.tmp.token,
    }),
  },
  {
    path: '/confirm-account/:userId/:token',
    name: 'confirm-account',
    component: () => lazyLoadView(import('./views/confirm-account.vue')),
    meta: {
      tmp: {},
      beforeResolve(routeTo, routeFrom, next) {
        routeTo.meta.tmp.token = routeTo.params.token
        routeTo.meta.tmp.userId = routeTo.params.userId

        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'home' })
        } else {
          next()
        }
      },
    },
    props: (route) => ({
      token: route.meta.tmp.token,
      userId: route.meta.tmp.userId,
    }),
  },
  {
    path: '/verify-phone',
    name: 'verify-phone',
    component: () =>
      lazyLoadView(
        import(/* webpackChunkName: "login" */ './views/verify-phone.vue')
      ),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        next()
      },
    },
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store.dispatch('auth/logOut')
        const authRequiredOnPreviousRoute = routeFrom.matched.some(
          (route) => route.meta.authRequired
        )
        // Navigate back to previous page, or home as a fallback
        next(authRequiredOnPreviousRoute ? { name: 'login' } : { ...routeFrom })
      },
    },
  },
  {
    path: '/loginredirect/:token',
    name: 'loginredirect',
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        const token = routeTo.params.token
        store.commit('auth/SET_TOKEN', token)
        store.commit('auth/SET_TRYING_TO_LOGIN', false)
        store
          .dispatch('auth/validate')
          .then((user) => {
            next({ name: 'user-page', params: { userId: user.id } })
          })
          .catch((e) => {
            next({ name: '404', params: { resource: 'Company' } })
          })
      },
    },
  },
]

function requiresCustomRedired() {
  const storageKey = 'redirect_after_login'
  const redirectAfterLogin = localStorage.getItem(storageKey)
  if (
    typeof redirectAfterLogin === 'string' &&
    redirectAfterLogin.substring(0, 4) === 'http'
  ) {
    localStorage.removeItem(storageKey)
    window.location.href = redirectAfterLogin
    return true
  }
  return false
}
